import { FetchSearchItemsParams, SearchItem } from '../types';
import fetchEndpoint from '../../services/fetchEndpoint';

export const getFilterKey = (searchType: string): string => {
  switch (searchType) {
    case 'DISEASES':
      return 'diseaseUMLSCUI';
    case 'GENES':
      return 'geneID';
    case 'VARIANTS':
      return 'strID';
    case 'CHEMICALS':
      return 'chemID';
    default:
      return '';
  }
};

export const splitIdents = (idents: string, searchType: string): string[] => {
  return searchType === 'CHEMICALS' ? idents.split(/(?<=\d)-(?=C)/) : idents.split('-');
};

export const fetchSearchItems = async (params: FetchSearchItemsParams): Promise<SearchItem[]> => {
  const { validInputs, searchType, selectedFilter, authorization, isAuthenticated, setAuthError } = params;

  const baseEndpoint = 'api/advancedsearch';
  const urlParams = new URLSearchParams({
    pattern: validInputs.join(','),
    filter: selectedFilter,
    type: searchType,
    ...(isAuthenticated ? {} : { skey: 'unauth' }),
  });

  const urlEndpoint = `${baseEndpoint}?${urlParams.toString()}`;

  try {
    const res = await fetchEndpoint(urlEndpoint, authorization, setAuthError);
    const payload = res?.payload;
    return payload ? payload[searchType.toLowerCase()] : [];
  } catch (error: unknown) {
    console.error('Error:', error);
    return [];
  }
};

export const compareIdents = (arr1: string[], arr2: string[]): boolean => {
  if (arr1.length !== arr2.length) return false;
  const sorted1 = [...arr1].sort();
  const sorted2 = [...arr2].sort();
  return sorted1.every((v, i) => v === sorted2[i]);
};
